import { TW_AppBlogArticle, TW_AppBlogParagraphMargin } from "@utils/twClasses";

export default function Introduction() { 
    return (
        <div className={TW_AppBlogArticle}>
            <h1 className="mb-6 text-3xl font-semibold text-black">Bienvenue dans Compozz !</h1>
            <p className={TW_AppBlogParagraphMargin}>
                Compozz est un outil de gestion de données qui permet de créer des modèles de données, des tableaux de bord et des rapports.
            </p>
            <p className={TW_AppBlogParagraphMargin}>Suivez ce guide pour réaliser votre premier espace de travail et découvrir toutes les fonctionnalités de votre nouvel outil. </p>
            <p className={TW_AppBlogParagraphMargin}>
                Si vous avez des questions, n'hésitez pas à nous contacter à contact@compozz.com.
            </p>
        </div>
    )
}